import { TRANSLATIONS } from "./catalog";
import type { AppLanguage, TranslationKey, TranslationValues } from "./types";

export const DEFAULT_APP_LANGUAGE: AppLanguage = "es";

export const isAppLanguage = (value: unknown): value is AppLanguage =>
  typeof value === "string" && value in TRANSLATIONS;

export const translate = (
  key: TranslationKey,
  language: AppLanguage = DEFAULT_APP_LANGUAGE,
  values: TranslationValues = {},
): string =>
  TRANSLATIONS[language][key].replace(/{{(\w+)}}/g, (placeholder, name) =>
    String(values[name] ?? placeholder),
  );
